import React from 'react';

export default class Page9 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Use the table below to think about the approach you’d use to
                                                persuade people to commit. Then, consider how you could build on
                                                this approach or develop and use other methods to increase your
                                                effectiveness.</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport people_active tablesrink">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top" colSpan="2"
                                                        className="green_curve green_curve1">Primary
                                                        Preference:&nbsp;</th>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="subheading2bg subTableHEading">Secondary
                                                        Preference:&nbsp;
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">How can I build on my
                                                        approach? <textarea rows="2" cols="2"
                                                                            className="textDev2"
                                                                            name="response1" id="response1"
                                                                            onBlur="saveResponseBuyIn(this.value,1,300,this.id);">df</textarea>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">How can I develop the other areas
                                                        of gaining commitment? <textarea rows="2" cols="2"
                                                                                         className="textDev2"
                                                                                         name="response2"
                                                                                         id="response2"
                                                                                         onBlur="saveResponseBuyIn(this.value,2,300,this.id);">dfhz</textarea>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">What opportunities do I have or
                                                        will I have in the future? <textarea rows="2" cols="2"
                                                                                             className="textDev2"
                                                                                             name="response3"
                                                                                             id="response3"
                                                                                             onBlur="saveResponseBuyIn(this.value,3,300,this.id);">fh</textarea>
                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page10')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}